import { render, staticRenderFns } from "./CrmLayout.vue?vue&type=template&id=7e61707d&scoped=true"
import script from "./CrmLayout.vue?vue&type=script&lang=js"
export * from "./CrmLayout.vue?vue&type=script&lang=js"
import style0 from "./CrmLayout.vue?vue&type=style&index=0&id=7e61707d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e61707d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e61707d')) {
      api.createRecord('7e61707d', component.options)
    } else {
      api.reload('7e61707d', component.options)
    }
    module.hot.accept("./CrmLayout.vue?vue&type=template&id=7e61707d&scoped=true", function () {
      api.rerender('7e61707d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/CrmLayout.vue"
export default component.exports